import { useMemo } from "react";
import { Platform, Text as RNText, StyleSheet, TextProps } from "react-native";

// Wrapper component based on https://github.com/facebook/react-native/issues/29232#issuecomment-889767516

const Text = ({ style, children, ...rest }: TextProps) => {
    const flattenStyle = useMemo(() => StyleSheet.flatten(style), [style]);

    const lineHeight = flattenStyle?.lineHeight;
    // The nested <Text> below is a workaround, not content: it defeats `adjustsFontSizeToFit`,
    // whose Android auto-sizing only measures a single text node. Auto-sizing wins — it sets its
    // own line height anyway, which is what the workaround was compensating for.
    const needsLineHeightWorkaround =
        Platform.OS === "android" && !!lineHeight && !rest.adjustsFontSizeToFit;

    return (
        <RNText style={style} {...rest}>
            {children}
            {needsLineHeightWorkaround && <RNText style={{ lineHeight: lineHeight + 0.001 }} />}
        </RNText>
    );
};

export default Text;
